import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import Divider from '@material-ui/core/Divider';

import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LabelIcon from '@material-ui/icons/Label';
import { useMediaQuery, Theme } from '@material-ui/core';
import { useTranslate, DashboardMenuItem, MenuItemLink, setSidebarVisibility } from 'react-admin';
import SubMenu from './SubMenu';
import { AppState } from '../types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MenuContainer } from './MenuContainer';

type MenuName = 'mnuAdminTool' | 'mnuUtility' | 'mnuTestOperations' | 'mnuReports';

interface Props {
    dense: boolean;
    logout: () => void;
    onMenuClick: () => void;
}

const Menu: FC<Props> = ({ onMenuClick, dense, logout }) => {
    const [state, setState] = useState({
        mnuAdminTool: false,
        mnuUtility: false,
        mnuTestOperations: true,
        mnuReports: false
    });
    const [rights, setRights] = useState([]);
    const [categories, setCategories] = useState<string[]>([]);

    const MyOnMenuClick = () => {
        window.scrollTo(0, 0);
        dispatch(setSidebarVisibility(false));
        //onMenuClick();
    }

    const translate = useTranslate();
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xs')
    );
    const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);
    useSelector((state: AppState) => state.theme); // force rerender on theme change

    const handleToggle = (menu: MenuName) => {
        setState(state => ({ ...state, [menu]: !state[menu] }));
    };
    const dispatch = useDispatch();
    // useEffect(() => {
    //     dispatch(setSidebarVisibility(false));
    // },[]);
    const onMenuClick1 = () => {
        dispatch(setSidebarVisibility(false));
    }
    let role = localStorage.getItem("role");
    
    //let isPrincipal = (role == 'principal');
    //let isFaculty = (role == 'faculty');
    //let isStudent = (role == 'student');

    const SetMenuData = () => {
        let menuData = [];
        let menu = localStorage.getItem("menu");
        if (menu) {
            menuData = JSON.parse(menu);
        }
        var outObject = menuData.reduce(function (a: any, e: any) {
            let estKey = (e['ModuleCategory']);
            (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e);
            return a;
        }, {});
        var keys = Object.keys(outObject);
        setCategories(keys);
        setRights(outObject);
        //console.log(outObject, "===outObject===");
    }

    // Initialize menu data once on mount
    useEffect(() => {
        SetMenuData();
        console.log("EMPLOYEE LOGGED IN ");
    }, []);

    let uid = localStorage.getItem("userId");
    const url = "/employees/" + uid;

    // Use a darker background on mobile so the drawer is not plain white
    const mobileMenuStyle = isXSmall
        ? { backgroundColor: '#263238', minHeight: '100%' }
        : {};

    return (
        <div style={mobileMenuStyle}>
            {' '}
            {<DashboardMenuItem onClick={onMenuClick1} sidebarIsOpen={open} />} 
            {categories
                ?.filter((item: string) => item !== "Dashboard")
                .map((item: string, index: number) => (
                    <MenuContainer
                        key={index}
                        onMenuClick={MyOnMenuClick}
                        sidebarIsOpen={open}
                        dense={dense}
                        caption={item}
                        items={rights[item]}
                    />
                ))
            }

            <Divider />
            
            <MenuItemLink
                to={`/changepassword`}
                primaryText="Change Password"
                leftIcon={<VpnKeyIcon />}
                onClick={onMenuClick1}
                sidebarIsOpen={open}
                dense={dense}
            />

            {logout}
            <Divider />
        </div>
    );
};

export default Menu;
